// Estados que devuelve el backend para el envío de números de serie a la APP Copec.
// El texto y el color viven aquí para que las dos pantallas que los muestran
// digan exactamente lo mismo.
export const COPEC_SYNC_STATUS = {
  no_aplica: { label: "", variant: null, show: false },
  no_configurado: { label: "APP Copec: sin configurar", variant: "secondary", show: true },
  desactivado: { label: "APP Copec: desactivado", variant: "secondary", show: true },
  pendiente: { label: "APP Copec: no enviado", variant: "secondary", show: true },
  datos_incompletos: { label: "APP Copec: faltan datos", variant: "warning", show: true },
  enviado: { label: "APP Copec: enviado", variant: "primary", show: true },
  desactualizado: { label: "APP Copec: datos cambiados", variant: "info", show: true },
  error: { label: "APP Copec: error", variant: "danger", show: true },
  // La marca elegida está desactivada en la configuración: no se envía a
  // propósito, así que va en gris y no ofrece el envío.
  marca_excluida: { label: "APP Copec: no se envía", variant: "secondary", show: true },
};

// Estados desde los que tiene sentido ofrecer el envío sin pedir confirmación
// extra: o no se ha enviado nunca, o los datos cambiaron desde el último envío.
export const COPEC_ESTADOS_ENVIABLES = [
  "pendiente",
  "datos_incompletos",
  "desactualizado",
  "error",
];

export const COPEC_ORIGENES = {
  manual: "Manual",
  auto: "Automático",
  retry: "Reintento",
  cli: "Consola",
};

export const copecMetaFromStatus = (status) =>
  COPEC_SYNC_STATUS[status] || COPEC_SYNC_STATUS.pendiente;
